import { render, staticRenderFns } from "./QuranProgramSchedules.vue?vue&type=template&id=c3cf528c&"
import script from "./QuranProgramSchedules.vue?vue&type=script&lang=js&"
export * from "./QuranProgramSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports